import React from 'react';

const ChartBar3: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 17C3.55228 17 4 17.4477 4 18V21C4 21.5523 3.55228 22 3 22C2.44772 22 2 21.5523 2 21V18C2 17.4477 2.44772 17 3 17Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 12C9.55228 12 10 12.4477 10 13V21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21V13C8 12.4477 8.44772 12 9 12Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 7C15.5523 7 16 7.44772 16 8V21C16 21.5523 15.5523 22 15 22C14.4477 22 14 21.5523 14 21V8C14 7.44772 14.4477 7 15 7Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 2C21.5523 2 22 2.44772 22 3V21C22 21.5523 21.5523 22 21 22C20.4477 22 20 21.5523 20 21V3C20 2.44772 20.4477 2 21 2Z"
      />
    </svg>
  );
};

export default ChartBar3;
